import {Base64Object, validateBase64ObjectFileSize} from '@coolcolduk/util';
import deleteStorageFilesByPrefix from '../../helper/firebase/storage/deleteStorageFilesByPrefix';
import uploadStorageBase64 from '../../helper/firebase/storage/uploadStorageBase64';
import extractFileExtension from '../../utils/file/extractFileExtension';
import {env} from '../../config/env';

/**
 * Uploads avatar to Storage and returns the download URL.
 * Caller should update user doc with photoUrl or deleteField() when clearing.
 */
export default async function uploadUserAvatar(
  uid: string,
  avatar: Base64Object | undefined,
): Promise<string | undefined> {
  await deleteStorageFilesByPrefix(`public/${uid}`, 'avatar');
  if (!avatar) {
    return undefined;
  }
  validateBase64ObjectFileSize(
    avatar,
    env.sizeLimit.avatar,
    `Avatar size exceeds limit of ${env.sizeLimit.avatar} bytes`,
  );
  const ext = extractFileExtension(avatar.name);
  const path = `public/${uid}/avatar.${ext}`;
  return uploadStorageBase64(avatar, path);
}
